import { ChevronRight } from "lucide-react";

export const FloatingCTA = () => {
  return (
    <a
      href="#get-started"
      data-testid="floating-mobile-cta"
      className="fixed bottom-0 left-0 right-0 z-50 flex md:hidden items-center justify-center gap-2 bg-orange-500 px-6 py-4 font-display text-base font-bold uppercase tracking-wider text-white"
    >
      See If I Qualify
      <ChevronRight size={20} />
    </a>
  );
};
